import { render, staticRenderFns } from "./NormalSearchNav206.vue?vue&type=template&id=9f0a8fc2&scoped=true"
import script from "./NormalSearchNav206.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav206.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a8fc2",
  null
  
)

export default component.exports